import { render, staticRenderFns } from "./Prize.vue?vue&type=template&id=05391b7d&scoped=true&"
import script from "./Prize.vue?vue&type=script&lang=js&"
export * from "./Prize.vue?vue&type=script&lang=js&"
import style0 from "./Prize.vue?vue&type=style&index=0&id=05391b7d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05391b7d",
  null
  
)

export default component.exports